// extracted by mini-css-extract-plugin
export var breedpage = "BreedPage-module--breedpage--794a8";
export var pagecontent = "BreedPage-module--pagecontent--4308e";
export var sharewrapper = "BreedPage-module--sharewrapper--18a06";